<template>
    <div class="biosys">
        <link type="text/css" rel="stylesheet" href="/css/backSideStyle_custom.css"/>
        <b-container>
            <b-row class="justify-content-center">
                <div class="w-50">
                    <!--Logo圖標-->
                    <div>
                        <h1 class="hdlogo">&nbsp;</h1>
                    </div>
                    <!--標題文字-->
                    <div class="text-center">
                        <label class="text-center h2">登入後臺管理系統</label>
                    </div>
                    <!--登入頁-->
                    <b-form class="mt-5">
                        <!--帳號-->
                        <b-form-group label="帳號" label-for="username" class="text-left">
                            <b-form-input id="username"
                                type="text"
                                placeholder="請輸入帳號"
                                maxlength="15"
                                v-model="login.acc">
                            </b-form-input>
                        </b-form-group>
                        <!--密碼-->
                        <b-form-group label="密碼" label-for="pawd" class="text-left">
                            <b-row>
                                <!--登入密碼欄位-->
                                <b-col>
                                    <b-form-input id="pawd"
                                        :type="password.type"
                                        placeholder="請輸入密碼"
                                        maxlength="12"
                                        v-model="login.pwd"
                                        @keyup.enter="userLogin()">
                                    </b-form-input>
                                    <a href="#" @click="showPwdEye()">
                                        <img class="showeye" v-bind:src="'/images/backend/' + password.image" alt="顯示或隱藏明碼"/>
                                    </a>
                                </b-col>
                                <!--忘記密碼-->
                                <b-col class="Login_ForgetPwd">
                                    <a v-b-modal.modal-forgetPwd variant="success">>>忘記密碼？</a>
                                    <!--忘記密碼彈出視窗-->
                                    <b-modal
                                        id="modal-forgetPwd"
                                        v-model="forgetPwdShow"
                                        title="忘記密碼"
                                        ok-only>
                                        <template #modal-footer>
                                            <button
                                                v-b-modal.modal-close_visit
                                                class="btn btn-success btn-sm m-1"
                                                @click="functionForgetPwd">
                                                送出
                                            </button>
                                        </template>
                                        <p>
                                            請輸入您的帳號並完成驗證碼驗證，系統將寄送密碼重設通知信至您帳號所綁定的電子郵件信箱。請依信件指示設定新密碼。
                                        </p>
                                        <p>
                                            ※ 密碼重設連結僅限使用一次，且於 30 分鐘內有效，請於收到信件後儘速完成設定。<br>
                                            ※ 若您尚未設定電子郵件，或無法收到信件，請聯絡系統管理員協助處理。
                                        </p>
                                        <b-row>
                                            <b-col>
                                                <label for="title">帳號</label>
                                                <b-form-input
                                                    id="title"
                                                    v-model="forgetPwd.acc"
                                                    maxlength="15"
                                                    type="text"
                                                    placeholder="請輸入帳號">
                                                </b-form-input>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col>
                                                <label for="code">驗證碼</label>
                                                <b-form-input
                                                    id="code"
                                                    type="text"
                                                    maxlength="6"
                                                    placeholder="請輸入圖形驗證碼"
                                                    v-model="forgetPwd.code">
                                                </b-form-input>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col class="mt-2"><img width="100%" :src="imageCode" class="mb-3" />
                                            </b-col>
                                            <b-col>
                                                <a
                                                    href="javascript:void(0)"
                                                    class="reload"
                                                    title="點我可重新產生驗證碼"
                                                    @click="getImageCode">
                                                    <img src="/images/backend/icon-restart.png" alt="點我可重新產生驗證碼" />
                                                </a>
                                            </b-col>
                                        </b-row>
                                    </b-modal>
                                </b-col>
                            </b-row>
                        </b-form-group>
                        <b-row>
                            <b-col>
                                <b-form-group
                                    label="圖形驗證碼"
                                    label-for="code"
                                    class="text-left">
                                    <b-form-input
                                        id="code"
                                        type="text"
                                        maxlength="6"
                                        placeholder="請輸入圖形驗證碼"
                                        v-model="login.code"
                                        class=" p-4"
                                        @keyup.enter="userLogin()">
                                    </b-form-input> 
                                </b-form-group>
                            </b-col>
                            <b-col class="Login_Image_Code"> 
                                <img width="100%" :src="imageCode" alt="驗證碼圖形" />
                            </b-col>
                            <b-col class="Login_icon_restart">
                                <a
                                    href="javascript:void(0)"
                                    class="reload"
                                    title="點我可重新產生驗證碼"
                                    @click="getImageCode">
                                    <img src="/images/backend/icon-restart.png"  alt="點我可重新產生驗證碼" class="mt-4" />
                                </a>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-md-center">
                                <b-button size="lg" @click="userLogin" variant="success" class="w-50">登入</b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </div>
            </b-row>
        </b-container>
    </div>
</template> 

<script>
export default{
    components: {
    },
    data() {
        return{
            //標頭
            header:{
                text1: '國立臺灣大學生物產業傳播暨發展學系',
            },
            sideBarActive:'',
            imageCode: "",
            //登入資訊
            login: {
                acc: null,
                pwd: null,
                code: null,
            },
            //密碼欄位設定
            password:{
                show:false,
                type: "password",
                image: "eye.png",
            },
            //忘記密碼
            forgetPwd:{
                acc:null,
                code: null,
            },
            //
            forgetPwdShow: false,

            //API設定區
            apiGetImageCode:(data)=> 
                this.userRequest.post("bicd/GetImageCode",data),
            apiBackendLogin:(data)=> 
                this.userRequest.post("bicd/BackendLogin",data),
            apiUserInfo:(data)=> 
                this.userRequest.post("bicd/UserInfo",data),
        };
    },
    mounted(){
        //初始化
        this.init();
    },
    methods:{
        //初始化
        init(){
            this.getImageCode();
            let json = {
                TYPE: "CHECKSESSION",
                login_SELECT:{},
            }
            this.FunctionToken(this.checkLogin,json);

            this.showPwdEye(null,'init');
        },
        //系統登入
        userLogin() {
            let json ={ 
                TYPE: "ADMINLOGIN",
                login_SELECT:{
                    Id: this.login.acc,
                    EnCodePass: this.login.pwd,
                    ImgCode: this.login.code,
                },
            }
            this.FunctionToken(this.Login,json);
        },
        //忘記密碼
        functionForgetPwd(){
            let json ={
                TYPE: "FORGET",
                user_info_FORGET:{
                    userAccount: this.forgetPwd.acc,
                    ImgCodePass: this.forgetPwd.code
                },
            }
            this.FunctionToken(this.ForgetPwd,json);
        },
        //取得驗證圖
        getImageCode(){
            this.apiGetImageCode()
                .then((res) => {
                    const json = JSON.parse(res.data);
                    if (json.Status) {
                        let jsonImage = JSON.parse(json.Data);
                        this.imageCode = jsonImage.Image;
                        this.imageCodeArr = jsonImage.Code.split("");
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        //判斷是否已登入
        checkLogin(data){
            this.apiBackendLogin(data)
                .then((res) => {
                    const json = JSON.parse(res.data);
                    if (json.Status) {
                        this._go("/backend/");
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        //登入
        Login(data){
            this.apiBackendLogin(data)
            .then((res) => {
                let json = JSON.parse(res.data);
                this.getImageCode();
                if (json.Status) {
                    sessionStorage.setItem("LoginName", json.Data);
                    sessionStorage.setItem("LoginAcc", this.login.acc);
                    this._go("/backend/");
                } else if (json.Data.includes("/ForgetPwd?")) {
                    alert("密碼過期（超過六個月未變更）");
                    this._go(json.Data);
                } else {
                    this.login.code = "";
                    alert(json.Data);
                }
            })
            .catch((err) => {
                console.log(err);
            });
        },
        //忘記密碼
        ForgetPwd(data){
            this.apiUserInfo(data)
                .then((res) => {
                    const json =JSON.parse(res.data);
                    this.getImageCode();
                    if (json.Status){
                        this.forgetPwdShow = false;
                        alert('密碼重設通知信已發送至您帳號所綁定的電子郵件信箱，請前往收信並依照信中指示完成密碼設定。\r\n\r\n※ 重設密碼連結僅於 30 分鐘內有效，請儘速完成設定。\r\n※ 若未收到信件，請檢查垃圾郵件匣，或聯絡系統管理員協助處理。  ')
                        this.forgetPwd={
                            acc: null,
                            code: null,
                        };
                    }else{
                        alert(json.Data);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    }
};
</script>